import React, { useState, useEffect, Fragment } from "react";
import Card from "olive-react-myoneui/lib/Card";
import EventSlot from "./EventSlot";
import { dayNames, chunk, RenderDots, monthsShort } from "./utils";
import { calendarModuleName } from '../../../constants/config';
import { useTranslation } from 'react-i18next';

export function WeekCalender({
  frameDays,
  frameEvents,
  selectedDate,
  changedDate,
  handleListingDateChange,
  timeZone
}) {
  const { t } = useTranslation(calendarModuleName);

  return (
    <>
      {" "}
      <div className="days-list mb-3">
        {Object.keys(frameDays).map((key) => {
          const currentDay = frameDays[key];
          const eventKey = `${currentDay.year}-${currentDay.month}-${currentDay.day}`;
          const hasEvents = frameEvents[eventKey]?.length > 0;

          return (
          <div
            className={
              "day " + (frameDays[key].date == selectedDate ? "active" : "")
            }
            key={key}
            onClick={() =>
              handleListingDateChange(
                frameDays[key].year,
                frameDays[key].month - 1,
                frameDays[key].day
              )
            }
          >
            <span>{frameDays[key].dayName}</span>
            <h1>{frameDays[key].day}</h1>
            {hasEvents && (
              <RenderDots totalEvents={frameEvents[eventKey].length} />
            )}
          </div>
          )
        })}
      </div>
      <span className="card-divider my-3" />
      <div className="eventlist-wrapper">
        {typeof frameEvents[changedDate] !== "undefined" &&
        Object.keys(frameEvents[changedDate]).length > 0 ? (
          Object.keys(frameEvents[changedDate]).map((key) => (
            <EventSlot
              key={`event_calendar_${key}`}
              className="mb-3"
              event={frameEvents[changedDate][key]}
              timeZone={timeZone}
            />
          ))
        ) : (
          <Card className={`empty-block-card`}>
            <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
              <div className="empty-block">
                <h6>
                  <strong>{t('no_schedule_title')}</strong>
                </h6>
                <p>{t('no_schedule_message')}</p>
              </div>
            </Card.Body>
          </Card>
        )}
      </div>
    </>
  );
}

export function MonthCalender({
  frameDays,
  selectedDate,
  frameEvents,
  handleListingDateChange,
  timeZone,
  isMonthCalendarShown
}) {
  const { t } = useTranslation(calendarModuleName);
  var _calenderInformation = [];
  const [calenderInformation, setCalenderInformation] = useState({
    firstWeek: [],
    restOfWeeks: [],
  });
  useEffect(() => {
    _calenderInformation = [];
    const totalDaysInMonth = Object.keys(frameDays).length;
    if (totalDaysInMonth > 0) {
      let monthStartObject = frameDays[1],
        monthEndObject = frameDays[totalDaysInMonth];
      let monthStartLoop = dayNames.indexOf(frameDays[1]["dayName"]);
      monthStartLoop = monthStartLoop === 0 ? 7 : monthStartLoop;
      let monthEndLoop = 42 - (monthStartLoop + totalDaysInMonth);

      if (monthStartLoop > 0) {
        for (let i = 0; i < monthStartLoop; i++) {
          let givenDate = new Date(
            monthStartObject.year,
            monthStartObject.month - 1,
            monthStartObject.day
          );
          givenDate.setDate(givenDate.getDate() - (monthStartLoop - i));
          _calenderInformation.push({
            day: ("0" + givenDate.getDate()).slice(-2),
            dayName: dayNames[givenDate.getDay()],
            month: parseInt(("0" + (givenDate.getMonth() + 1)).slice(-2)),
            year: givenDate.getFullYear(),
            date: givenDate.toLocaleDateString(),
            dateOutsideMonth: true,
          });
        }
      }

      for (const [day, frameDay] of Object.entries(frameDays)) {
        _calenderInformation.push({ ...frameDay, dateOutsideMonth: false });
      }

      if (monthEndLoop > 0) {
        for (let i = 0; i < monthEndLoop; i++) {
          let givenDate = new Date(
            monthEndObject.year,
            monthEndObject.month - 1,
            monthEndObject.day
          );
          givenDate.setDate(givenDate.getDate() + (i + 1));
          _calenderInformation.push({
            day: ("0" + givenDate.getDate()).slice(-2),
            dayName: dayNames[givenDate.getDay()],
            month: parseInt(("0" + (givenDate.getMonth() + 1)).slice(-2)),
            year: givenDate.getFullYear(),
            date: givenDate.toLocaleDateString(),
            dateOutsideMonth: true,
          });
        }
      }
      let _calenderInformationPieces = chunk(_calenderInformation, 7);
      setCalenderInformation({
        firstWeek: _calenderInformationPieces[0],
        restOfWeeks: [
          _calenderInformationPieces[1],
          _calenderInformationPieces[2],
          _calenderInformationPieces[3],
          _calenderInformationPieces[4],
          _calenderInformationPieces[5],
        ],
      });
    }
  }, [frameDays]);

  const selectedDateEvents = frameEvents[selectedDate] || {};
  const eventListWrapperClass = isMonthCalendarShown
    ? "eventlist-wrapper month-selected"
    : "eventlist-wrapper";

  const parseDate = (selectedDate) => {
    if (!selectedDate) return null;

    // Check if the format is DD/MM/YYYY or MM/DD/YYYY
    const parts = selectedDate.split(/[\/\-\.]/);

    if (parts.length === 3) {
        let [first, second, third] = parts;
        
        if (parseInt(first) > 12) {
            return new Date(`${third}-${second}-${first}`);
        } else if (parseInt(second) > 12) {
            return new Date(`${third}-${first}-${second}`);
        }
    }
    
    return new Date(selectedDate);
  }

  const formattedDate = parseDate(selectedDate);

  const selectedMonth = formattedDate.toLocaleString("default", { month: "long" });

  const sortedEvents = Object.entries(frameEvents)
  .sort(([dateA], [dateB]) => new Date(dateB) - new Date(dateA));
  return (
    <>
    <div className="calendar-month-wrapper mb-3">
      {/* Render day names in .weekdays */}
      {calenderInformation.firstWeek.length > 0 && (
        <ul className="weekdays myk_stu-cal-weekdays" key="ul_weekdays_1">
          {calenderInformation.firstWeek.map((firstWeek) => (
            <li key={`${firstWeek.year}_${firstWeek.month}_${firstWeek.day}`}>
              <span>{firstWeek.dayName}</span>
            </li>
          ))}
        </ul>
      )}

      {/* Render days in .days */}
      <div className="calendar-days">
        {calenderInformation.firstWeek.length > 0 && (
          <ul className="days" key="ul_days_1">
            {calenderInformation.firstWeek.map((firstWeek) => (
              <li
                key={`${firstWeek.year}_${firstWeek.month}_${firstWeek.day}`}
                onClick={() =>
                  handleListingDateChange(
                    firstWeek.year,
                    firstWeek.month - 1,
                    firstWeek.day
                  )
                }
              >
                <span
                  {...(firstWeek.dateOutsideMonth
                    ? { className: "prevnext-month-days" }
                    : {})}
                >
                  {firstWeek.day}
                </span>
                {typeof frameEvents[
                  `${firstWeek.year}-${firstWeek.month}-${firstWeek.day}`
                ] !== "undefined" &&
                !firstWeek.dateOutsideMonth &&
                frameEvents[
                  `${firstWeek.year}-${firstWeek.month}-${firstWeek.day}`
                ].length > 0 ? (
                  <RenderDots
                    totalEvents={
                      frameEvents[
                        `${firstWeek.year}-${firstWeek.month}-${firstWeek.day}`
                      ].length
                    }
                  />
                ) : (
                  ""
                )}
              </li>
            ))}
          </ul>
        )}

        {calenderInformation.restOfWeeks.length > 0 && (
          <ul className="days" key="ul_days_2">
            {calenderInformation.restOfWeeks.map((calenderRow, index) => (
              <Fragment key={`row_${index}`}>
                {calenderRow.map((calenderColumn) => (
                  <li
                    key={`${calenderColumn.year}_${calenderColumn.month}_${calenderColumn.day}`}
                    onClick={() =>
                      handleListingDateChange(
                        calenderColumn.year,
                        calenderColumn.month - 1,
                        calenderColumn.day
                      )
                    }
                  >
                    <span
                      {...(calenderColumn.dateOutsideMonth
                        ? { className: "prevnext-month-days" }
                        : {})}
                    >
                      {calenderColumn.day}
                    </span>
                    {typeof frameEvents[
                      `${calenderColumn.year}-${calenderColumn.month}-${calenderColumn.day}`
                    ] !== "undefined" &&
                    !calenderColumn.dateOutsideMonth &&
                    frameEvents[
                      `${calenderColumn.year}-${calenderColumn.month}-${calenderColumn.day}`
                    ].length > 0 ? (
                      <RenderDots />
                    ) : (
                      ""
                    )}                    
                  </li>
                ))}
              </Fragment>
            ))}
          </ul>
        )}
      </div>
    </div>

    {/* Event List */}
    <div className="eventlist-wrapper-block">
      <h5 className="eventlist-date">Events in {selectedMonth}</h5>
      <div className={eventListWrapperClass}>
        {sortedEvents.some(([_, events]) => events.length > 0) ? (
          sortedEvents.map(([date, events], index) => (
            <div key={`month_event_${index}`} className="eventlist-date-group">
              {events.map((event, idx) => (
                <EventSlot
                  key={`event_calendar_${index}_${idx}`}
                  className="mb-3"
                  event={event}
                  timeZone={timeZone}
                />
              ))}
            </div>
          ))
        ) : (
          <Card className="empty-block-card">
            <Card.Body className="p-0 text-center empty-block-wrapper d-flex align-items-center justify-content-center">
              <div className="empty-block">
                <h6>
                  <strong>{t("No Events for this Month")}</strong>
                </h6>
                <p className="mb-0">{t("Once admin assign events, it will show up here.")}</p>
              </div>
            </Card.Body>
          </Card>
        )}
      </div>
    </div>
  </>
  );
}
